<template>
    <div class="Frame">
        <div class="ShopperTableIndex">
            <div class="ShopperTableIndexText">
                <h1>{{ this.risorse["CarrelloTitolo"] }}</h1>
                <p v-html=" this.risorse['CarrelloTesto']"></p>
                <div class="Form">
                    <div class="FormRow">
                        <div class="FormBoxWide FormTextArea">
                            <div class="Label">{{ this.risorse["NoteOrdine"] }}</div>
                            <div class="Field"><textarea :placeholder="this.risorse['ScriviQui']" v-model="this.noteOrdine"></textarea></div>
                        </div>
                    </div>
                </div> 
            </div>
            <div class="ShopperTableIndexAddBox">
                <!-- Inizio pannello ordina adesso -->
                <div class="AddShopBox">
                    <div class="AddShopPanel">
                        <div class="Frame">
                            <div class="AddShopPanelTable">
                                <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                    <tbody>
                                        <tr>
                                            <td v-html=" this.risorse['TotalProd']"></td>
                                            <td>{{this.simboloValuta}} {{this.formatNumber((this.totalArt ), 2, ',', '.')}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{this.risorse["TotalSpSped"]}}</td>
                                            <td>{{this.simboloValuta}} {{this.formatNumber((this.spSped ), 2, ',', '.')}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ this.risorse["TotaleOrdine"] }}</td>
                                            <td>{{this.simboloValuta}} {{this.formatNumber((this.totalCart ), 2, ',', '.')}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="!this.CheckOutAbilitato" class="Button Disabled Iconed AddShop"><a href="javascript:void(0)">{{ this.risorse["OrdinaOra"] }}</a></div>
                            <div v-else class="Button CustomColor Iconed AddShop"><a href="javascript:void(0)" @click="this.showModal=true">{{ this.risorse["OrdinaOra"] }}</a></div>
                            <div v-if="this.CalcolaSp" class="Button SelectedItem CustomColor Iconed Calc">
                                <a href="javascript:void(0)" @click="this.calcolaSpSped">{{this.risorse["CalcSpSped"]}}</a>
                            </div>
                            <div v-else class="Button SelectedItem CustomColor Iconed Calc Disabled"><a>{{this.risorse["CalcSpSped"]}}</a></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ModalSendOrder v-model="this.showModal" />
</template>

<script>

import {priceMixin, valutaMixin, risorseMixin} from "@/mixin.js";
import ModalSendOrder from "@/components/modals/ModalSendOrder.vue";
import CartService from '@/services/cart.service.js';


export default {
    name: "CartSummaryBottom",
    data(){
        return {
            showModal: false,
            noteOrdine: "",
            CalcolaSp: true
        }
    },
    watch: {
        noteOrdine(newVal){
            this.$parent.$data.noteOrdine = newVal;
        },
        indSped: function(newValues,oldValues){
            if(newValues != oldValues && newValues != null){
                this.$store.commit('setCheckOutAbilitato',false);
            }
        }
    },
    computed: {
        totalArt: function(){
            return this.$store.getters.getPrezzoTotale;
        },
        spSped: function(){
            return (this.$store.getters.getSpSpedizione?.TotSpeseSpedizione ?? 0);
        },
        totalCart: function(){
            return this.$store.getters.getPrezzoTotale + (this.$store.getters.getSpSpedizione?.TotSpeseSpedizione ?? 0);
        },
        indSped: function(){
            return this.$store.getters.getShippingAddress; 
        },
        CheckOutAbilitato: function(){
            let rb = this.$store.getters.getCarrello?.Righe?.filter(x => x.IsBackorder == 1);
            let r = this.$store.getters.getCarrello?.Righe?.filter(x => x.IsBackorder == 0);
            if((rb != null && rb.length > 0) && (r == null || r.length == 0)){
                this.CalcolaSp = false;
                return true;
            }else{
                this.CalcolaSp = true;
                return this.$store.getters.getCheckOutAbilitato;
            }
        }

    },
    props:{
        shippindAddress: Number
    },
    mixins: [priceMixin, valutaMixin, risorseMixin],
    components:{
        ModalSendOrder
    },
    methods:{
        calcolaSpSped: function(){
            let indirizzo = this.$store.getters.getShippingAddress;
            CartService.CalcolaSpSpedizione(this.$store.getters.getToken, indirizzo, 'B2B').then(
                (data) => {
                    this.$store.commit("setSpSpedizione", data);
                    this.$store.commit('setCheckOutAbilitato',true);
                }
            );
        }
    }
}
</script>